import {
  Alignment,
  Autoformat,
  BlockQuote,
  Bold,
  CKFinder,
  CKFinderUploadAdapter,
  CloudServices,
  Essentials,
  FileRepository,
  Font,
  GeneralHtmlSupport,
  Heading,
  Highlight,
  Image,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  Mention,
  Paragraph,
  PasteFromOffice,
  PictureEditing,
  SourceEditing,
  Strikethrough,
  Table,
  TableColumnResize,
  TableToolbar,
  TextTransformation,
  Underline
} from "ckeditor5";

export const CONFIG = {
  PLUGINS: [
    Alignment,
    Highlight,
    Font,
    SourceEditing,
    Autoformat,
    BlockQuote,
    Bold,
    Strikethrough,
    CKFinder,
    CKFinderUploadAdapter,
    CloudServices,
    Essentials,
    Heading,
    Image,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    List,
    Mention,
    Paragraph,
    PasteFromOffice,
    PictureEditing,
    Table,
    TableColumnResize,
    TableToolbar,
    TextTransformation,
    Underline,
    SourceEditing,
    GeneralHtmlSupport,
    FileRepository
  ],
  TOOLBAR: {
    htmlSupport: {
      allow: [
        {
          name: /.*/,
          attributes: true,
          classes: true,
          styles: true
        }
      ]
    },
    items: [
      'heading', '|',
      'bold', 'italic', 'underline', 'strikeThrough', '|',
      'alignment', '|', 'uploadImage',
      'link', 'bulletedList', 'numberedList', '|',
      'blockQuote', 'insertTable', '|', 'outdent',
      'indent',
      'highlight', 'fontColor', 'fontBackgroundColor', '|',
      'undo', 'redo', 'sourceEditing', 'preview'
    ],
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    xxxitems: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      '|',
      'link',
      'uploadImage',
      'insertTable',
      'blockQuote',
      'mediaEmbed',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'sourceEditing',
      'outdent',
      'indent',
      'undo',
      'redo',
      'preview'
    ]
  }

};
